<button class="payment color-8E6339" nz-button nzType="primary" (click)="submit()">付费查看</button>

<!-- 支付 -->
<section class="mask flex-perfect-center" *ngIf="payModalShow">
    <section class="modal-box-background-music">
        <div class="modal-box-title flex-vertical-center-between">
            <div class="title f-bold">收银台</div>
            <img class="close-icon cursor-pointer" src="assets/image/close.png" alt="关闭" (click)="choosePay()" loading="lazy">
        </div>
        <div class="modal-box-content">

            <div class="order-info flex-vertical-center-between fs-14">
                <div class="order-No">订单编号：{{ordersNo}}</div>
                <div class="price">应付金额：<span class="fs-18 f-bold">￥{{price}}</span></div>
            </div>

            <div class="payment-code">
                <div class="payment-platform flex-perfect-center fs-16">
                    <img class="payment-platform-icon" src="assets/icon/wx_pay.png" alt="微信支付" loading="lazy">
                    微信支付
                </div>
                <div class="qr-code">
                    <app-qr-code [data]="codeUrl" [width]="200"></app-qr-code>
                </div>
                <div class="payment-hint flex-vertical-center">
                    <img class="icon" src="assets/icon/ewm.png" alt="微信支付" loading="lazy">
                    <div>
                        <div>请使用微信扫码</div>
                        <div>二维码以完成支付</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
